export default __webpack_public_path__ + "static/media/illustrator.a57480b4.svg";